import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  GcButtonComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

import { FileMetaData } from '../../../../installation-report-content-v2/self-inspection-v2/self-inspection-v2-entities';
import { SharedModule } from '../../../../shared.module';
import { FileData } from '../../report-input-entities';
import { ReportInputsService } from '../../service/report-inputs.service';
import { OptionsButtonComponent } from '../options-button/options-button.component';
import {
  calculatePopupPosition,
  PopupPosition,
} from './options-popup/options-popup-helper';
import { OptionsPopupComponent } from './options-popup/options-popup.component';

@Component({
  selector: 'app-file-handler',
  imports: [
    CommonModule,
    SharedModule,
    GcButtonComponent,
    IpoTranslatePipe,
    OptionsPopupComponent,
    OptionsButtonComponent,
  ],
  templateUrl: './file-handler.component.html',
  styleUrl: './file-handler.component.scss',
})
export class FileHandlerComponent {
  @Input() id: string;
  @Input() data: FileData;
  @Input() optionsButton? = true;
  @Input() disableUndo?: boolean;

  @Output() viewImages = new EventEmitter();
  @Output() filesDownload = new EventEmitter<
    {
      fileName: string;
      fileId: string;
    }[]
  >();
  @Output() fileDelete = new EventEmitter<string>();

  showPopup = false;
  clickedFile: FileMetaData = {} as FileMetaData;
  popupPosition: PopupPosition | null = null;

  constructor(private readonly reportInputsService: ReportInputsService) {}

  openPopup(fileMetaData: FileMetaData) {
    this.showPopup = true;
    this.clickedFile = fileMetaData;
  }

  closePopup() {
    this.showPopup = false;
    this.clickedFile = {} as FileMetaData;
  }

  handleClickFile(event: Event, fileMetaData: FileMetaData) {
    this.popupPosition = calculatePopupPosition(event);
    this.openPopup(fileMetaData);
  }

  handleClickDownload() {
    this.filesDownload.emit([
      {
        fileId: this.clickedFile.fileId,
        fileName: this.clickedFile.fileName,
      },
    ]);
    this.closePopup();
  }

  handleClickDelete() {
    this.fileDelete.emit(this.clickedFile.fileId);
    this.closePopup();
  }

  handleUploadFiles(event: Event) {
    this.reportInputsService.setUploadFiles(this.id, event);
  }

  get showUploadButton() {
    return !(
      this.data.type === 'IMAGE' &&
      this.data.imageAmount &&
      this.data.imageAmount > 0
    );
  }

  get isSelfInspectionDone(): boolean {
    switch (this.data.type) {
      case 'IMAGE':
        return !!this.data.imageAmount;
      case 'FILE':
        return !!this.data.files?.length;
      default:
        return false;
    }
  }
}
